// extracted by mini-css-extract-plugin
export default {"root":"ebH2RNidNBGUcm5F47SH"};